const initURLFieldValue = require("./initURLFieldValue");
const initMktoReferrerFieldValue = require("./initMktoReferrerFieldValue");
const initMunchkinIdFieldValue = require("./initMunchkinIdFieldValue");
const initMktoTrkFieldValue = require("./initMktoTrkFieldValue");
const initLocaleField = require("./initLocaleField");

/**
 * @param globalMarketoFieldsContainer {HTMLElement}
 * @return {void}
 */
module.exports = function initUniformFormFields(globalMarketoFieldsContainer) {
    const marketoURLField = globalMarketoFieldsContainer.querySelector('[name="URL"]');
    if (marketoURLField instanceof HTMLInputElement) {
        initURLFieldValue(marketoURLField);
    }

    const mktoReferrerField = globalMarketoFieldsContainer.querySelector('[name="_mktoReferrer"]');
    if (mktoReferrerField instanceof HTMLInputElement) {
        initMktoReferrerFieldValue(mktoReferrerField);
    }

    const munchkinIdField = globalMarketoFieldsContainer.querySelector('[name="munchkinId"]');
    if (munchkinIdField instanceof HTMLInputElement) {
        initMunchkinIdFieldValue(munchkinIdField);
    }

    const mktoTrkField = globalMarketoFieldsContainer.querySelector('[name="_mkt_trk"]');
    if (mktoTrkField instanceof HTMLInputElement) {
        initMktoTrkFieldValue(mktoTrkField);
    }

    const localeField = globalMarketoFieldsContainer.querySelector('[name="Locale__c"]');
    if (localeField instanceof HTMLInputElement) {
        initLocaleField(localeField);
    }
}